import { CuboidPartsArrays } from '@App/app/entities/layer/cuboid.model';
import {
  CUBOID_PART,
  CUBOID_PART_STRICT,
  LAYER_TYPES,
} from '@App/app/entities/layer/enums/layer-types.enum';
import { Injectable } from '@angular/core';
import { Mesh } from 'babylonjs';
import { UtilsService } from '../../../utils-service/utils.service';
import { RectangleToolsAzimuthService } from '../shared/rectangle-tools-azimuth.service';
import { RectangleToolsGeometryService } from '../shared/rectangle-tools-geometry.service';
import { RectangleToolsSaveService } from '../shared/rectangle-tools-save.service';
import { RectangleToolsService } from '../shared/rectangle-tools-service';
import { RectangleToolsUtilsService } from '../shared/rectangle-tools-utls.service';

@Injectable({
  providedIn: 'root',
})
export class CuboidService extends RectangleToolsService {
  activePart: CUBOID_PART = CUBOID_PART.NONE;
  highlightedSample: { part: CUBOID_PART; i: number } = {
    part: CUBOID_PART.NONE,
    i: -1,
  };
  samples: CuboidPartsArrays<Mesh> = { 1: [], 2: [], 3: [] };

  constructor(
    private rectangleToolsUtilsService: RectangleToolsUtilsService,
    private utilsService: UtilsService,
    private rectangleToolsSaveService: RectangleToolsSaveService,
    private rectangleToolsAzimuthService: RectangleToolsAzimuthService,
    private geometryService: RectangleToolsGeometryService,
  ) {
    super(
      rectangleToolsUtilsService,
      utilsService,
      rectangleToolsSaveService,
      rectangleToolsAzimuthService,
    );
  }

  generateCuboidBoundingBox() {
    try {
      const result = this.geometryService.calculateSidesData(
        this.samples[CUBOID_PART.FRONT_BACK],
        this.samples[CUBOID_PART.LEFT_RIGHT],
        this.samples[CUBOID_PART.TOP_BOTTOM],
      );
      this.save(
        LAYER_TYPES.CUBOID,
        result.topPlaneNormal,
        result.originalSurfacePlaneNormal,
        result.centerPosition,
        result.adjacentSurfaceLength,
        result.originalSurfaceLength,
        result.topBottomSurfaceLength,
        this.samples[CUBOID_PART.FRONT_BACK],
      );
      this.clearSamples();
    } catch (err) {
      this.clearSamples();
      this.utilsService.catchToolCreationError(err);
    }
  }

  // eslint-disable-next-line complexity
  setActivePart(part: CUBOID_PART) {
    const isConflictingPart =
      (part === CUBOID_PART.LEFT_RIGHT && this.samples[CUBOID_PART.TOP_BOTTOM].length) ||
      (part === CUBOID_PART.TOP_BOTTOM && this.samples[CUBOID_PART.LEFT_RIGHT].length);
    if (!isConflictingPart) {
      this.activePart = this.activePart === part ? CUBOID_PART.NONE : part;
      this._dataChange$.next();
    }
  }

  highlightSample(part: CUBOID_PART_STRICT, i: number) {
    this.highlightSamplePoint(part, i);
    this._dataChange$.next();
  }

  deleteSample(part: CUBOID_PART_STRICT, i: number) {
    this.deleteSamplePoint(part, i);
    this._dataChange$.next();
  }

  clearSamples() {
    this.clearSamplesPoints();
    this._dataChange$.next();
  }
}
